import { render, staticRenderFns } from "./CoreSidebar.vue?vue&type=template&id=a9763610"
import script from "./CoreSidebar.vue?vue&type=script&lang=ts"
export * from "./CoreSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports